import { useTranslation } from 'react-i18next';
import { parseTikTokPostId, tTikTokRichContent } from '../../TikTok.types';

export function TikTokRichMessage({
  content,
}: {
  content: tTikTokRichContent;
}) {
  const { t } = useTranslation('tiktok/tiktok');
  if (content.kind === 'share_post') {
    const id = parseTikTokPostId(content.share_post.item_id);
    return id ? (
      <a
        href={`https://www.tiktok.com/video/${id}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('capabilities.viewPost')}
      </a>
    ) : null;
  }
  return (
    <div className="TikTokRichMessage" data-testid="tiktok-question-card">
      <p>{content.template.title}</p>
      <ul>
        {content.template.buttons.map((button, index) => (
          <li key={button.id ?? index}>{button.title}</li>
        ))}
      </ul>
    </div>
  );
}
